import {addDays, differenceInCalendarDays} from 'date-fns';

import type {BigCalendarEvent} from '../types/BigCalendarEvent';

/**
 * New boundaries for an all-day-header event dropped on a day. The header is day-granular, so the
 * event shifts by whole calendar days and only the day of `dropDate` matters — both boundaries
 * keep the time of day they had, and so the duration is preserved.
 */
export function getHeaderEventDropRange(event: BigCalendarEvent, dropDate: Date) {
  const dayShift = differenceInCalendarDays(dropDate, event.start);

  return {
    start: addDays(event.start, dayShift),
    end: addDays(event.end, dayShift),
  };
}
